module.exports = __webpack_public_path__ + "img/leftside_300.7d5f1a15.jpg";